// extracted by mini-css-extract-plugin
export default {"FriendsListContainer":"FriendsList_FriendsListContainer__N3DtY","Title":"FriendsList_Title__msAdK"};